<template>
  <v-card
    max-width="750"
    class="mx-auto"
    color="grey-lighten-3"
    :disabled="loading"
    :loading="loading"
  >
    <v-layout>
      <CustomAppBar :page="1" :title="$t('info_card.title_page1')" />
      <v-main>
        <v-card-text
          ><v-row
            ><v-col class="v-col-12 v-col-sm-6">
              <h5> 
                {{ $t("info_card.degree") }}
                {{
                  inlineTranslator({
                    th: level_name_TH,
                    en: level_name_EN,
                  })
                }}
              </h5></v-col
            ></v-row
          ><v-row
            ><v-col class="v-col-12 v-col-sm-5">
              <h5>
                {{ $t("info_card.faculty") }}
                {{
                  inlineTranslator({
                    th: faculty_name_TH,
                    en: faculty_name_EN,
                  })
                }}
              </h5></v-col
            >
            <v-col class="v-col-12 v-col-sm-7"
              ><h5>
                {{ $t("info_card.curriculum") }}
                {{
                  inlineTranslator({
                    th: curriculum_name_TH,
                    en: curriculum_name_EN,
                  })
                }}
              </h5></v-col
            ><v-col class="v-col-12 v-col-sm-5"
              ><h5>
                {{ $t("info_card.name_th") }}
                {{ surrogated_student_info.STUDENT_FNAME_TH }}
              </h5></v-col
            >
            <v-col class="v-col-12 v-col-sm-7">
              <h5>
                {{ $t("info_card.surname_th")
                }}{{ surrogated_student_info.STUDENT_LNAME_TH }}
              </h5></v-col
            >
          </v-row></v-card-text
        ><v-divider></v-divider>
        <v-form v-model="form_validate_status" ref="form" :loading="loading">
          <v-card-text>
            <v-row>
              <v-col class="v-col-12 v-col-sm-6"
                ><h6>{{ $t("info_card.prename") }}</h6>
                <v-autocomplete
                  variant="outlined"
                  density="compact"
                  v-model="prename_id"
                  :items="prenames"
                  :item-title="(item) => objectTranslator(item, 'FULLNAME')"
                  :item-value="(item) => item.PREFIX_NAME_ID"
                  :rules="requiredRules"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <NameEn v-model="nameSurnameEN" />
          </v-card-text>
        </v-form>
        <v-divider></v-divider>
        <v-card-text
          ><div class="text-end">
            <v-btn color="primary" size="large" @click="saveData">{{
              is_lock_kmitl1 === true ? "Next" : "Save & Next"
            }}</v-btn>
          </div></v-card-text
        >
        <v-divider></v-divider>
        <v-card-text
          ><p>{{ $t("info_card.text_info") }}</p></v-card-text
        >
      </v-main>
    </v-layout>
  </v-card>
</template>

<script>
import { inlineTranslator, objectTranslator } from "@/helper/translator";
import CustomAppBar from "@/components/info_cards/CustomAppBar.vue";
import NameEn from "@/components/info_cards/NameEN.vue";
import { getById } from "@/helper/filter";
import GenericProvider from "@/services/generic.provider";
import PageProvider from "@/services/page.provider";
import UserProvider from "@/services/user.provider.js";
import validator from "@/helper/validator";

const genericService = new GenericProvider();
const pageService = new PageProvider();
const userProvider = new UserProvider();

export default {
  name: "PageOne",

  components: {
    NameEn,
    CustomAppBar,
  },

  data: () => ({
    form_validate_status: false,
    loading: false,
    nameSurnameEN: {
      nameEN: null,
      surnameEN: null,
    },
    levels: [
      {
        LEVEL_ID: "1",
        LEVEL_NAME_EN: "Undergraduate",
        LEVEL_NAME_TH: "ปริญญาตรี",
      },
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "Postgraduate",
        LEVEL_NAME_TH: "บัณฑิตศึกษา",
      },
      {
        LEVEL_ID: "3",
        LEVEL_NAME_EN: "Postgraduate",
        LEVEL_NAME_TH: "บัณฑิตศึกษา",
      },
    ],
    gender_id: null,
    prename_id: null,

    level_id: null,
    level_name_TH: null,
    level_name_EN: null,
    faculty_id: null,
    faculty_name_TH: null,
    faculty_name_EN: null,
    curriculum_id: null,
    curriculum_name_TH: null,
    curriculum_name_EN: null,
    is_lock_kmitl1: true,

    facultys: [],
    requiredRules: [validator.required],
  }),

  methods: {
    getById,
    inlineTranslator,
    objectTranslator,

    async getData() {
      this.loading = true;
      const data = await pageService.getPage1(this.uid).catch((error) => {
        this.$toast.error(JSON.stringify(error.response.data.message));
      });
      this.level_id = data.LEVEL_ID;
      this.faculty_id = data.FACULTY_ID;
      this.curriculum_id = data.CURRICULUM_ID;
      this.gender_id = data.GENDER_ID;
      this.prename_id = data.PREFIX_NAME_ID;
      this.nameSurnameEN.nameEN = data.STUDENT_FNAME_EN;
      this.nameSurnameEN.surnameEN = data.STUDENT_LNAME_EN;

      const refData_level = await getById(
        this.levels,
        this.level_id,
        "LEVEL_ID"
      );
      this.level_name_TH = refData_level.LEVEL_NAME_TH;
      this.level_name_EN = refData_level.LEVEL_NAME_EN;

      const data1 = await genericService
        .getRegistrarFaculty()
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      this.facultys = data1;

      const refData = await getById(
        this.facultys,
        this.faculty_id,
        "faculty_id"
      );
      this.faculty_name_TH = refData.faculty_name_th;
      this.faculty_name_EN = refData.faculty_name_en;

      const data2 = await genericService
        .getRegistrarCurriculum(
          this.level_id,
          this.faculty_id,
          this.curriculum_id
        )
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      this.curriculum_name_TH = data2[0].curriculum_name_th;
      this.curriculum_name_EN = data2[0].curriculum_name_en;

      const getLock = await userProvider
        .getLock(this.uid, "LOCK_KMITL1")
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      this.is_lock_kmitl1 = getLock.LOCK_KMITL1 == "0" ? false : true;

      this.loading = false;
    },

    async saveData() {
      if (this.form_validate_status === true) {
        if (this.is_lock_kmitl1 === false) {
          this.loading = true;
          const response = await pageService
            .setPage1({
              uid: this.uid,
              GENDER_ID: this.gender_id ?? null,
              PREFIX_NAME_ID: this.prename_id ?? null,
              STUDENT_FNAME_EN: this.nameSurnameEN.nameEN ?? null,
              STUDENT_LNAME_EN: this.nameSurnameEN.surnameEN ?? null,
            })
            .catch((error) => {
              this.$toast.error(JSON.stringify(error.response.data.message));
              this.loading = false;
            });
          if (response && response.status) {
            this.$toast.success(this.$t("toast.save_successfully"));
            this.$router.push("/page2");
          } else this.$toast.error(this.$t("toast.cannot_save"));
          this.loading = false;
        } else {
          this.$router.push("/page2");
        }
      } else {
        this.$toast.error(this.$t("toast.cannot_save"));
      }
    },
  },

  computed: {
    prenames() {
      let data = this.$store.state.ref.prenames;
      data = data.filter((item) => item.AGE === "adult");
      return data;
    },
    is_authorized_officer() {
      return this.$store.state.user.is_authorized_officer;
    },

    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },

    form_validate_status_computed() {
      return this.form_validate_status;
    },
  },

  watch: {
    prename_id(val) {
      if (val == "003") this.gender_id = "1";
      else this.gender_id = "2";
    },
  },

  async created() {
    // จะช่วยให้ได้ข้อมูลจากการเรียก API ก่อนมาแสดงที่ DOM Element ได้ทัน ถ้าใช้ created ไม่ทันได้เติมข้อมูลเลยเป็นว่าง T.T
    await this.$store.dispatch("user/getUserInfo");
    this.$store.dispatch("ref/getPrenames");
    this.getData();
  },
};
</script>

<style scoped></style>
